/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const data_source = {
  url: './', //así tiene que estar en el server
  //url: 'https://www.monitoreodepuentes.com/',
  token:null
};
